import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDirectionLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 14",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.616117 7.88388C0.127961 7.39573 0.127961 6.60427 0.616116 6.11612L5.61612 1.11612C6.10427 0.627961 6.89573 0.627961 7.38388 1.11612C7.87204 1.60427 7.87204 2.39573 7.38388 2.88388L3.26777 7L7.38388 11.1161C7.87204 11.6043 7.87204 12.3957 7.38388 12.8839C6.89573 13.372 6.10427 13.372 5.61612 12.8839L0.616117 7.88388Z",
		fill: "var(--color, #2882DE)"
	})
});
export default SvgDirectionLeft;
